import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "./LanguageContext";
import { getPersonalizedLanguageConfig } from "@/apis/apiCollection";
import { languageOptions } from ".";

function tpl(msg, values) {
  if (!values) return msg;
  return msg.replace(/\{([^}]+?)\}/gm, (match, name) => {
    return values[name] !== undefined ? values[name] : match;
  });
}

export const t = (config, values, namespace, dictionary) => {
  if (!dictionary) {
    dictionary = window.__langDictionary || {};
  }
  let id;
  let msg = "";
  if (typeof config === "object") {
    id = config.id;
    msg = config.defaultMessage;
  } else {
    id = config;
  }
  if (!id) return tpl(msg, values);
  const dict =
    namespace && typeof config === "string"
      ? dictionary[namespace] || {}
      : dictionary;
  const result = dict
    ? id.split(".").reduce((o, i) => o && o[i], dict) ?? (msg || id)
    : msg;

  if (typeof result === "string") {
    return tpl(result, values);
  }
  return msg ? tpl(msg, values) : id;
};

export const useTranslation = namespace => {
  const { userLanguage, dictionary, langConf } = useContext(LanguageContext);

  const _t = (config, values) => {
    return t(config, values, namespace, dictionary);
  };


  return { t: _t, userLanguage, langConf};
};
